import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../../component/shared/shared.service';
import { ActivatedRoute } from '@angular/router';
import {PromotionCodeService} from '../../master/services/promotion-code.service';
import {PromotionCode} from '../../master/model/promotion-code';
import {PromotionCodeLogService} from './../../report/services/promotion-code-log.service';
import {PromotionCodeLog} from './../../report/model/promotion-code-log';

@Component({
  selector: 'app-view-promo-code',
  templateUrl: './view-promo-code.component.html',
  styleUrls: ['./view-promo-code.component.css']
})
export class ViewPromoCodeComponent implements OnInit {
  loading: boolean=false;
  listLoading: boolean = false;
  promotionCodeList: PromotionCode[];
  promotionCodeLog: Array<PromotionCodeLog>;
  dataCount: number;
  user: any;
  filterDays:string = '2';
  selectedPromoCode: string;
  constructor(private _promotionCodeService: PromotionCodeService, private _promotionCodeLogService: PromotionCodeLogService) {

      }

  ngOnInit() {
    this.user = JSON.parse(sessionStorage.getItem('User'));
     this.getPromotionCodeDetail();
   }


  getPromotionCodeDetail(): void {
    this.listLoading = true;
    this._promotionCodeService.getPromotionCode(this.user.UserId).subscribe(
      data => {
          this.listLoading = false;
          this.promotionCodeList  = data;
      },
      error => {
          this.listLoading = false;
      }
    );
 }

 showData() {
this.listLoading = true;
this.dataCount = 0;
this._promotionCodeLogService.getPromotionCodeLogByCode(this.selectedPromoCode, this.filterDays).subscribe(data => {
   this.listLoading = false;
   this.promotionCodeLog = data;
   this.dataCount = data.length;
}, error => {

});

 }

 getPromotionCodeLog(code: string): void {
   this.selectedPromoCode = code;
  this.listLoading = true;
  this.dataCount = 0;
  this._promotionCodeLogService.getPromotionCodeLogByCode(code, this.filterDays).subscribe(data => {
     this.listLoading = false;
     this.promotionCodeLog = data;
     this.dataCount = data.length;
  }, error => {

  });
}

 ngAfterViewChecked() {
    // this._sharedService.emitChange(false);
  }
  ngOnDestroy() {
    // this._sharedService.emitChange(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/section/promocode/view-promo-code/view-promo-code.component.ts